<div class="w-full h-full flex justify-center items-center gap-4 bg-dark-50">
    <img class="h-10 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" src="./assets/favicon.png" />
    <mat-progress-spinner [diameter]="100" mode="indeterminate"></mat-progress-spinner>
</div>
